import { gql } from '@apollo/client';

export const GET_NOISE_EVENTS_BY_ALERT_ID_CLASSIFICATION = gql(`
  query GetNoiseEventsByAlertIdClassification($filter: GuidIdInFilter) {
    facility {
      alerts {
        noiseEvents(filter: $filter) {
          id
          classifications {
            classificationId
            noiseEventId
            utcModifiedTime
            isAiClassified
          }
          comments
          disregarded
        }
      }
    }
  }
`);
